module.exports = "<h2>Check Your Completion Certificate</h2>\n\n<ul>\n\t<li>All pages are uploaded</li>\n\t<li>All pages have the same date and time stamp</li>\n\t<li>You have signed and dated the document</li>\n\t<li>Property Owner has signed and dated the document</li>\n\t<li>If applicable, payment designees are listed</li>\n</ul>\n\n<p class=\"closing-note\">All uploaded documents will be reviewed by our closing team.</p>";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/documents/uploadDocumentsModal/completionCertificateChecklistTemplate.html
// module id = 554
// module chunks = 1